export default "__VITE_ASSET__DXdKvdPz__"